import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoadingPanelService } from 'src/app/shared/loading-panel/loading-panel.service';
import { ToastService, ToastType } from 'src/app/shared/toast/toast.service';
import { ConfigurationService } from '../services/configuration.service';
import { SvgIconComponent } from '../../shared/icons/svg-icon.component';
import { LayoutContainerComponent } from '../../controls/components/basic/layout-container/layout-container.component';
import { ContainerFluidDirective } from '../../controls/directives/container-fluid.directive';
import { LayoutRowComponent } from '../../controls/components/basic/layout-row/layout-row.component';
import { LayoutColumnComponent } from '../../controls/components/basic/layout-column/layout-column.component';
import { CheckboxComponent } from '../../controls/components/basic/checkbox/checkbox.component';
import { ButtonComponent } from '../../controls/components/basic/button/button.component';
import { ButtonPrimaryDirective } from '../../controls/directives/button-primary.directive';
import { ButtonSubmitDirective } from '../../controls/directives/button-submit.directive';
import { ButtonTertieryDirective } from '../../controls/directives/button-tertiery.directive';

@Component({
    selector: 'ep-importexport-settings',
    templateUrl: './importexport-settings.component.html',
    styleUrls: ['./importexport-settings.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SvgIconComponent, FormsModule, ReactiveFormsModule, LayoutContainerComponent, ContainerFluidDirective, LayoutRowComponent, LayoutColumnComponent, CheckboxComponent, ButtonComponent, ButtonPrimaryDirective, ButtonSubmitDirective, ButtonTertieryDirective]
})
export class ImportExportSettingsComponent implements OnInit {

    importExportSettings = {
        includeArtifacts: null,
    };

    formGroup: FormGroup = this.fb.group({
        includeArtifacts: this.fb.control(this.importExportSettings.includeArtifacts),
    });

    constructor(private fb: FormBuilder, private loadingPanelService: LoadingPanelService, private toastService: ToastService, private configurationService: ConfigurationService) { }

    ngOnInit(): void {
        this.refresh();
        this.formGroup.disable();
    }

    async refresh() {
        try {
            this.loadingPanelService.showLoadingPanelDirect('Loading...');
      
            await Promise.all([
              this.configurationService.getEffectiveSettingBoolean('IncludeArtifactsInExport').then(res => this.importExportSettings.includeArtifacts = res ?? true),
            ]);
      
            this.formPatch();
          }
          catch (err) {
            console.error(err);
            this.toastService.showToast('Failed to load data...', ToastType.error);
          }
          finally {
            this.loadingPanelService.hideLoadingPanel();
          }
    }

    formPatch() {
        this.formGroup.setValue({
            includeArtifacts: this.importExportSettings.includeArtifacts
        });
    }

    async formSubmit(): Promise<void> {
        try {
            this.loadingPanelService.showLoadingPanelDirect('Saving...');

            let includeArtifacts = this.formGroup.get('includeArtifacts').value;
            await Promise.all([
              this.configurationService.saveEffectiveSettingBoolean('IncludeArtifactsInExport', includeArtifacts ? true : false).then(res => this.importExportSettings.includeArtifacts = res),
            ]);
      
            this.formGroup.disable();
            this.toastService.showToast('Settings saved...', ToastType.success);
          }
          catch (err) {
            this.toastService.showToast('Failed to save settings ...', ToastType.error);
          }
          finally {
            this.loadingPanelService.hideLoadingPanel();
          }
    }

    formEdit() {
        this.formGroup.enable();
    }

    formCancel() {
        this.formPatch();
        this.formGroup.markAsUntouched();
        this.formGroup.markAsPristine();
        this.formGroup.disable();
    }
}
